import _ from "lodash";
export const isValidValue = ({ value }) => {
  if (_.isNumber(value)) {
    return Boolean(value);
  } else if (_.isString(value)) {
    return _.get(value.trim(), "length", 0) != 0;
  } else {
    return _.get(value, "length", 0) != 0;
  }
};
